/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardIDQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceStandardIDQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceStandardIDQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardIDQueryOperator>): ComplianceStandardIDQueryOperator {
        let obj = Object.assign(new ComplianceStandardIDQueryOperator(), model);
        ComplianceStandardIDQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardIDQueryOperator>): ComplianceStandardIDQueryOperator {
        if (!model) return null;
        return ComplianceStandardIDQueryOperator.newInstance(<ComplianceStandardIDQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardIDQueryOperator) {
        if (!obj) return;

        models.ComplianceStandardIDQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardIDQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceStandardIDQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Standard IDs to filter assessment history
     */
    standard_ids: Array<string>;

}
